module.exports = __webpack_public_path__ + "static/media/template-answer-select.f790d61e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/template-answer-select.svg
// module id = 823
// module chunks = 0